import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import SignupAsOrganizer from '../../components/commit-form/signup.organizer';
import SignupAsInvitee from '../../components/commit-form/signup.invitee';
import Title from '../../components/title';
import {
  userExists,
  showSigninFormSection,
  sendMagicLink,
  showModalInnerAlert,
  POST_CLAIM_COMMIT,
  SIGNUP_FORM_SECTION,
  SIGNIN_FORM_SECTION,
} from '../../actions';
import { FORM_NAME } from '../../components/commit-form';
import checkmarkDark from '../../img/checkmark-dark.svg';

class SignupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGuestSignup: false,
      email: null,
    };

    this.checkUserExistence = debounce(props.userExists, 500, { maxWait: 2000 });
    this.onEmailChange = this.onEmailChange.bind(this);
  }

  componentDidMount() {
    if (this.props.email) {
      this.props.userExists(this.props.email);
    }
  }

  componentDidUpdate() {
    this.props.change('_validationHack', new Date());
  }

  onEmailChange(ev) {
    this.setState({ email: ev.target.value });
    this.checkUserExistence(ev.target.value);
  }

  onSendGuestLink = () => {
    const content = (
      <span>
        <img src={checkmarkDark} alt="" className="mr-2 mb-1" />
        <strong>Check your inbox</strong> and click the link there then refresh this page.
      </span>
    );
    return this.props.sendMagicLink(this.state.email)
      .then(() => this.props.showModalInnerAlert(content, 'success'))
  }

  showingGuestSignup() {
    return this.props.method === 'guest';
  }

  renderForInvitee() {
    if (!this.props.shouldRender) return null;
    const props = {
      method: this.props.method,
      onLogin: this.props.showSigninFormSection,
      onFacebookConnect: this.props.onFacebookConnect,
      onEmailChange: this.onEmailChange,
      onSendGuestLink: this.onSendGuestLink,
    };
    return <SignupAsInvitee {...props} />;
  }

  renderForOrganizer() {
    if (!this.showingGuestSignup()) return null;
    const props = {
      onLogin: this.props.showSigninFormSection,
      onFacebookConnect: this.props.onFacebookConnect,
      onEmailChange: this.onEmailChange,
    };

    return <SignupAsOrganizer {...props} />;
  }

  render() {
    let form = this.renderForInvitee();
    if (this.props.postClaimVersion) {
      form = this.renderForOrganizer();
    }

    if (!form) return null;

    return (
      <div>
        <Title
          text={
            <FormattedMessage
              id="commitForm.signup.title"
              defaultMessage="Create Key Travel account"
            />
          }
          divider
        />
        {form}
      </div>
    )
  }
}

const mapStateToProps = ({ users, ui }) => {
  const user = users.byId[users.current];
  const shouldRender = !ui.formSections[SIGNIN_FORM_SECTION] &&
    (!user || ui.formSections[SIGNUP_FORM_SECTION]);
  return {
    postClaimVersion: ui.commitFormVersion === POST_CLAIM_COMMIT,
    shouldRender,
    email: user ? user.email : null,
    method: users.existence,
    user,
  };
};

const mapDispatchToProps = {
  userExists,
  showSigninFormSection,
  sendMagicLink,
  showModalInnerAlert,
  change: (field, value) => change(FORM_NAME, field, value),
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/signup.container.js